export function formatNumber(num: number): string {
  const str = num.toString();

  // Если число содержит от 4 до 6 цифр, вставляем пробел перед последними тремя цифрами
  if (str.length >= 4 && str.length <= 6) {
    return str.slice(0, str.length - 3) + ' ' + str.slice(str.length - 3);
  }

  return str;
}

export function formatCurrency(
  value: number,
  currency: string,
  position: 'prefix' | 'suffix' = 'suffix'
): string {
  const formatted = formatNumber(value);
  return position === 'prefix' ? `${currency}${formatted}` : `${formatted} ${currency}`;
}